import { GeocoderException } from './geocoder.exception';

export class InvalidCredentialsException extends GeocoderException {}
